import React from "react";

import Loader from "./Loader";
import styles from "./style.module.css";

const FullScreenLoader = () => {
  return (
    <div className={styles.container}>
      <Loader />
    </div>
  );
};

export default FullScreenLoader;
